import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { FuaFormData } from 'components/Assessments/FuaAssessment/types/FuaFormData'
import { MedicalBackgroundQuestionnaireItem } from 'components/Assessments/FuaAssessment/sections/MedicalBackground/questionnaire'
import { MusculoskeletalFormField } from './formField'

/**
 * Musculoskeletal subsection adapter
 * Handles musculoskeletal system assessment (2 fields - simplest after Lines/Drains)
 */
export class MusculoskeletalAdapter extends BaseSubsectionAdapter<FuaFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<FuaFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Musculoskeletal assessment fields
    const musculoskeletalAssessment = getAnswerValuesFromItems(
      flatAnswersArray,
      MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_MUSCULOSKELETAL_ASSESSMENT
    )

    const systemSummary = getAnswerValuesFromItems(
      flatAnswersArray,
      MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_SYSTEM_SUMMARY
    )?.at(0)

    return {
      [MusculoskeletalFormField.MUSCULOSKELETAL_MUSCULOSKELETAL_ASSESSMENT]:
        musculoskeletalAssessment,
      [MusculoskeletalFormField.MUSCULOSKELETAL_SYSTEM_SUMMARY]: systemSummary
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    return [
      {
        linkId:
          MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_MUSCULOSKELETAL_ASSESSMENT,
        value: this.getFormDataField(
          MusculoskeletalFormField.MUSCULOSKELETAL_MUSCULOSKELETAL_ASSESSMENT
        )
      },
      {
        linkId:
          MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_SYSTEM_SUMMARY,
        value: this.getFormDataField(MusculoskeletalFormField.MUSCULOSKELETAL_SYSTEM_SUMMARY)
      }
    ]
  }
}
